import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type CustomerSliceState = {
  ckey: string;
  summaryGroup: string;
  detailKey: string;
  isSerialProcess: boolean;
  selectedProcessIdsRef: { current: string[] };
};

export const customerInitialState: CustomerSliceState = {
  ckey: "",
  summaryGroup: "",
  detailKey: "",
  isSerialProcess: false,
  selectedProcessIdsRef: { current: [] }, // list of processes which are included in the aggregates
};

const customerSlice = createSlice({
  name: "customer",
  initialState: customerInitialState,
  reducers: {
    updateCustomerKey(
      state: CustomerSliceState,
      action: PayloadAction<string>
    ) {
      if (["bad-url", "unauthorized"].includes(action.payload)) {
        return;
      }
      state.ckey = action.payload;
    },
    updateSummaryGroup(
      state: CustomerSliceState,
      action: PayloadAction<string>
    ) {
      state.summaryGroup = action.payload;
    },
    updateDetailKey(state: CustomerSliceState, action: PayloadAction<string>) {
      state.detailKey = action.payload;
    },
  },
});
export const { updateCustomerKey, updateSummaryGroup, updateDetailKey } =
  customerSlice.actions;
export default customerSlice.reducer;
